import React, { useState } from 'react';
import { useMediaQuery } from '@material-ui/core';
import { Link as LinkScroll } from 'react-scroll';
import ButtonBase from '../../Buttons/ButtonBase';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import SwipeableViews from 'react-swipeable-views';
import Pagination from '../../slideOneCard/Pagination';
import './FreemiumConected.scss';

const bullet = '/img/freemiumMembershipLanding/Conected/bullet.svg'

const useStyles = makeStyles((theme) => ({
    container: {
        justifyContent: 'center'
    },
    buttonStyle: {
        minWidth: 293,
    },
    root: {
        flexGrow: 1,
    },
    bullets: {
        width:36
    },

    header: {
        display: 'flex',
        alignItems: 'center',
        height: 50,
        paddingLeft: theme.spacing(4),
        backgroundColor: theme.palette.background.default,
    },
    img: {
        height: 255,
        display: 'block',
        maxWidth: 400,
        overflow: 'hidden',
        width: '100%',
    },
   
    swipeableViews: {
        cursor: 'grab',
        '&:active': {
            cursor: 'grabbing',
        }
    },
}))
const styles = {
    dotStyles: {
        height: 32,
        width: 32,
        cursor: "pointer",
        border: 0,
        background: "none",
        padding: 3,
        margin: 12,
        outline: "none",
    
      dot: {
        backgroundColor: "#e7e7e7",
        height: 14,
        width: 14,
        borderRadius: 8,
        margin: 0,
      },
      active: {
        backgroundColor: '#35b9b6',
      },
      backDot: {
        height: 24,
        width: 24,
        borderRadius: 12,
        margin: 0,
        outline: "none",
        backgroundColor: "rgba(231, 231, 231, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        cursor:'pointer'
      },
      backDot_active: {
        height: 24,
        width: 24,
        borderRadius: 12,
        margin: 0,
        outline: 'none',
        backgroundColor: 'rgba(53, 185, 183, 0.5)',
    
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      },
   
    },
  };
  
const FreemiumConected = () => {

    const isMobile = useMediaQuery('(max-width: 999.98px)')

    const classes = useStyles()
    const theme = useTheme();
    const [ index, setIndex ] = useState(0);
    const [ activeStep, setActiveStep ] = useState(0);

    const handleChangeIndex = index => {
        setActiveStep(index)
        setIndex(index);
    };

    const handleStepChange = (step) => {
        setIndex(step);
        setActiveStep(step);
    };

    return (
        <div className='FreemiumConected'>
            <div className='FreemiumConected-container'>
                <p className='FreemiumConected-title'>¿Conectado o fuera de línea?</p>
                <p className='FreemiumConected-subtitle'>
                    La transformación digital en el <b>sector legal</b> ya está aquí, por eso la reputación 
                    y el posicionamiento online son clave. <b>¿En qué página aparece su despacho en Google?</b>
                </p>
                <div className='FreemiumConected-subContainer'>

                    {/* DESKTOP IMAGE */}
                    {isMobile ?
                        null :
                        <div className='FreemiumConected-lawyerImageContainer'>
                            <div className='FreemiumConected-border'/>
                            <img
                                className='FreemiumConected-lawyerImage'
                                src='/img/freemiumMembershipLanding/Conected/bicolor-lawyer.png'
                                alt='lawyer'
                            />
                        </div>
                    }

                    {/* CAROUSEL OR DESKTOP MODE */}
                    {isMobile ?
                        // MOBILE CAROUSEL
                        <div className={classes.root}>
                            <Pagination
                                dots={2}
                                size="large"
                                index={index}
                                dotStyles={styles.dotStyles}
                                onChangeIndex={handleChangeIndex}
                            />
                            <SwipeableViews
                                axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                                index={activeStep}
                                onChangeIndex={handleStepChange}
                                className={classes.swipeableViews}
                                enableMouseEvents
                            >
                                <div className='FreemiumConected-firstSlide'>
                                    <div className='FreemiumConected-titles1'>
                                        <div className='FreemiumConected-titles1_container'>
                                            <p className='FreemiumConected-titles1_white'>Abogado</p>
                                            <p className='FreemiumConected-titles1_blue'>TRADICIONAL</p>
                                        </div>
                                    </div>
                                    <div className='FreemiumConected-firstSlide_container'>
                                        <img
                                            className='FreemiumConected-firstSlide_lawyerImage'
                                            src='/img/freemiumMembershipLanding/Conected/half-gray.png'
                                            alt='half-gray'
                                        />
                                    </div>
                                    <div className='FreemiumConected-gridContainerSlide1'>                            
                                        <div className='FreemiumConected-grid1'>
                                            <div className='FreemiumConected-square1'>
                                                <div className='FreemiumConected-square1_container'>
                                                    <img
                                                        className='FreemiumConected-square1_img'
                                                        src='/img/freemiumMembershipLanding/Conected/icon1.svg'
                                                        alt='despacho'
                                                    />
                                                    <p className='FreemiumConected-square1_text'>
                                                        Las posibilidades de <b>EXPANSIÓN</b> profesional son <b>LIMITADAS</b>
                                                    </p>
                                                </div>
                                                <div className='FreemiumConected-square1_bulletContainer'>
                                                    <div className='FreemiumConected-square1_border' />
                                                    <img
                                                        className='FreemiumConected-square1_bullet'
                                                        src={bullet}
                                                        alt='bullet'
                                                    />
                                                </div>
                                            </div>
                                            <div className='FreemiumConected-square3'>
                                                <div className='FreemiumConected-square3_container'>
                                                    <img
                                                        className='FreemiumConected-square3_img'
                                                        src='/img/freemiumMembershipLanding/Conected/icon3.svg'
                                                        alt='servicios'
                                                    />
                                                    <p className='FreemiumConected-square3_text'>
                                                        Sus servicios se conocen solo
                                                        entre su círculo de clientes
                                                    </p>
                                                </div>
                                                <div className='FreemiumConected-square3_bulletContainer'>
                                                    <div className='FreemiumConected-square3_border' />
                                                    <img
                                                        className='FreemiumConected-square3_bullet'
                                                        src={bullet}
                                                        alt='bullet'
                                                    />
                                                </div>
                                            </div>
                                            <div className='FreemiumConected-square5'>
                                                <div className='FreemiumConected-square5_container'>
                                                    <img
                                                        className='FreemiumConected-square5_img'
                                                        src='/img/freemiumMembershipLanding/Conected/icon5.svg'
                                                        alt='servicios'
                                                    />
                                                    <p className='FreemiumConected-square5_text'>
                                                        Sus <b>RECOMENDACIONES</b> son <b>INVISIBLES</b> para <b>CLIENTES POTENCIALES</b> en internet
                                                    </p>
                                                </div>
                                                <div className='FreemiumConected-square5_bulletContainer'>
                                                    <div className='FreemiumConected-square5_border' />
                                                    <img
                                                        className='FreemiumConected-square5_bullet'
                                                        src={bullet}
                                                        alt='bullet'
                                                    />
                                                </div>
                                            </div>
                                            <div className='FreemiumConected-square7'>
                                                <div className='FreemiumConected-square7_container'>
                                                    <img
                                                        className='FreemiumConected-square7_img'
                                                        src='/img/freemiumMembershipLanding/Conected/icon7.svg'
                                                        alt='servicios'
                                                    />
                                                    <p className='FreemiumConected-square7_text'>
                                                        <b>RESISTENCIA</b> a la implementación de <b>HERRAMIENTAS DIGITALES</b> para la gestión de su despacho
                                                    </p>
                                                </div>
                                                <div className='FreemiumConected-square7_bulletContainer'>
                                                    <div className='FreemiumConected-square7_border' />
                                                    <img
                                                        className='FreemiumConected-square7_bullet'
                                                        src={bullet}
                                                        alt='bullet'
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='FreemiumConected-secondSlide'>
                                    <div className='FreemiumConected-titles2'>
                                        <div className='FreemiumConected-titles2_container'>
                                            <p className='FreemiumConected-titles2_white'>Abogado</p>
                                            <p className='FreemiumConected-titles2_blue'>DIGITAL</p>
                                        </div>
                                    </div>
                                    <div className='FreemiumConected-secondSlide_container'>
                                        <img
                                            className={'FreemiumConected-secondSlide_lawyerImage'}
                                            src='/img/freemiumMembershipLanding/Conected/half-colorful.png'
                                            alt='half-colorful'
                                        />
                                    </div>
                                    <div className='FreemiumConected-gridContainerSlide2'>                                        
                                        <div className='FreemiumConected-grid2'>
                                            <div className='FreemiumConected-square2'>
                                                <div className='FreemiumConected-square2_container'>
                                                    <img
                                                        className='FreemiumConected-square2_img'
                                                        src='/img/freemiumMembershipLanding/Conected/icon2.svg'
                                                        alt='reputación'
                                                    />
                                                    <p className='FreemiumConected-square2_text'>
                                                        Se enfoca en gestionar su marca personal
                                                        y <b>REPUTACIÓN</b> a través de internet
                                                    </p>
                                                </div>
                                                <div className='FreemiumConected-square2_bulletContainer'>
                                                    <div className='FreemiumConected-square2_border' />
                                                    <img
                                                        className='FreemiumConected-square2_bullet'
                                                        src={bullet}
                                                        alt='bullet'
                                                    />
                                                </div>
                                            </div>
                                            <div className='FreemiumConected-square4'>
                                                <div className='FreemiumConected-square4_container'>
                                                    <img
                                                        className='FreemiumConected-square4_img'
                                                        src='/img/freemiumMembershipLanding/Conected/icon4.svg'
                                                        alt='visible'
                                                    />
                                                    <p className='FreemiumConected-square4_text'>
                                                        Es <b>VISIBLE</b> en las búsquedas relacionadas
                                                        con su especialidad en Google
                                                    </p>
                                                </div>
                                                <div className='FreemiumConected-square4_bulletContainer'>
                                                    <div className='FreemiumConected-square4_border' />
                                                    <img
                                                        className='FreemiumConected-square4_bullet'
                                                        src={bullet}
                                                        alt='bullet'
                                                    />
                                                </div>
                                            </div>
                                            <div className='FreemiumConected-square6'>
                                                <div className='FreemiumConected-square6_container'>
                                                    <img
                                                        className='FreemiumConected-square6_img'
                                                        src='/img/freemiumMembershipLanding/Conected/icon6.svg'
                                                        alt='visible'
                                                    />
                                                    <p className='FreemiumConected-square6_text'>
                                                        Las <b>RECOMENDACIONES</b> y opiniones sobre sus servicios en
                                                        internet le ayudan a conseguir clientes potenciales
                                                    </p>
                                                </div>
                                                <div className='FreemiumConected-square6_bulletContainer'>
                                                    <div className='FreemiumConected-square6_border' />
                                                    <img
                                                        className='FreemiumConected-square6_bullet'
                                                        src={bullet}
                                                        alt='bullet'
                                                    />
                                                </div>
                                            </div>
                                            <div className='FreemiumConected-square8'>
                                                <div className='FreemiumConected-square8_container'>
                                                    <img
                                                        className='FreemiumConected-square8_img'
                                                        src='/img/freemiumMembershipLanding/Conected/icon8.svg'
                                                        alt='visible'
                                                    />
                                                    <p className='FreemiumConected-square8_text'>
                                                        Implementa en su despacho herramientas
                                                        digitales <b>INNOVADORAS</b> que optimizan sus servicios
                                                    </p>
                                                </div>
                                                <div className='FreemiumConected-square8_bulletContainer'>
                                                    <div className='FreemiumConected-square8_border' />
                                                    <img
                                                        className='FreemiumConected-square8_bullet'
                                                        src={bullet}
                                                        alt='bullet'
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </SwipeableViews>
                        </div> :
                        // DESKTOP GRID
                        <div className='FreemiumConected-gridContainer'>

                            <div className='FreemiumConected-titlesGrid'>
                                <div className='FreemiumConected-titles1'>
                                    <div className='FreemiumConected-titles1_container'>
                                        <p className='FreemiumConected-titles1_white'>Abogado</p>
                                        <p className='FreemiumConected-titles1_blue'>TRADICIONAL</p>
                                    </div>
                                </div>
                                <div className='FreemiumConected-titles2'>
                                    <div className='FreemiumConected-titles2_container'>
                                        <p className='FreemiumConected-titles2_white'>Abogado</p>
                                        <p className='FreemiumConected-titles2_blue'>DIGITAL</p>
                                    </div>
                                </div>
                            </div>
                            
                            <div className='FreemiumConected-grid1'>
                                <div className='FreemiumConected-square1'>
                                    <div className='FreemiumConected-square1_container'>
                                        <img
                                            className='FreemiumConected-square1_img'
                                            src='/img/freemiumMembershipLanding/Conected/icon1.svg'
                                            alt='despacho'
                                        />
                                        <p className='FreemiumConected-square1_text'>
                                            Las posibilidades de <b>EXPANSIÓN</b> profesional son <b>LIMITADAS</b>
                                        </p>
                                    </div>
                                    <div className='FreemiumConected-square1_bulletContainer'>
                                        <div className='FreemiumConected-square1_border' />
                                        <img
                                            className='FreemiumConected-square1_bullet'
                                            src={bullet}
                                            alt='bullet'
                                        />
                                    </div>
                                </div>
                                <div className='FreemiumConected-square2'>
                                    <div className='FreemiumConected-square2_container'>
                                        <img
                                            className='FreemiumConected-square2_img'
                                            src='/img/freemiumMembershipLanding/Conected/icon2.svg'
                                            alt='reputación'
                                        />
                                        <p className='FreemiumConected-square2_text'>
                                            Se enfoca en gestionar su marca personal
                                            y <b>REPUTACIÓN</b> a través de internet
                                        </p>
                                    </div>
                                    <div className='FreemiumConected-square2_bulletContainer'>
                                        <div className='FreemiumConected-square2_border' />
                                        <img
                                            className='FreemiumConected-square2_bullet'
                                            src={bullet}
                                            alt='bullet'
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className='FreemiumConected-grid2'>
                                <div className='FreemiumConected-square3'>
                                    <div className='FreemiumConected-square3_container'>
                                        <img
                                            className='FreemiumConected-square3_img'
                                            src='/img/freemiumMembershipLanding/Conected/icon3.svg'
                                            alt='servicios'
                                        />
                                        <p className='FreemiumConected-square3_text'>
                                            Sus servicios se conocen solo
                                            entre su círculo de clientes
                                        </p>
                                    </div>
                                    <div className='FreemiumConected-square3_bulletContainer'>
                                        <div className='FreemiumConected-square3_border' />
                                        <img
                                            className='FreemiumConected-square3_bullet'
                                            src={bullet}
                                            alt='bullet'
                                        />
                                    </div>
                                </div>
                                <div className='FreemiumConected-square4'>
                                    <div className='FreemiumConected-square4_container'>
                                        <img
                                            className='FreemiumConected-square4_img'
                                            src='/img/freemiumMembershipLanding/Conected/icon4.svg'
                                            alt='visible'
                                        />
                                        <p className='FreemiumConected-square4_text'>
                                            Es <b>VISIBLE</b> en las búsquedas relacionadas
                                            con su especialidad en Google
                                        </p>
                                    </div>
                                    <div className='FreemiumConected-square4_bulletContainer'>
                                        <div className='FreemiumConected-square4_border' />
                                        <img
                                            className='FreemiumConected-square4_bullet'
                                            src={bullet}
                                            alt='bullet'
                                        />
                                    </div>
                                </div>
                            </div>
                            
                            <div className='FreemiumConected-grid3'>
                                <div className='FreemiumConected-square5'>
                                    <div className='FreemiumConected-square5_container'>
                                        <img
                                            className='FreemiumConected-square5_img'
                                            src='/img/freemiumMembershipLanding/Conected/icon5.svg'
                                            alt='servicios'
                                        />
                                        <p className='FreemiumConected-square5_text'>
                                            Sus <b>RECOMENDACIONES</b> son <b>INVISIBLES</b> para <b>CLIENTES POTENCIALES</b> en internet
                                        </p>
                                    </div>
                                    <div className='FreemiumConected-square5_bulletContainer'>
                                        <div className='FreemiumConected-square5_border' />
                                        <img
                                            className='FreemiumConected-square5_bullet'
                                            src={bullet}
                                            alt='bullet'
                                        />
                                    </div>
                                </div>
                                <div className='FreemiumConected-square6'>
                                    <div className='FreemiumConected-square6_container'>
                                        <img
                                            className='FreemiumConected-square6_img'
                                            src='/img/freemiumMembershipLanding/Conected/icon6.svg'
                                            alt='visible'
                                        />
                                        <p className='FreemiumConected-square6_text'>
                                            Las <b>RECOMENDACIONES</b> y opiniones sobre sus servicios en
                                            internet le ayudan a conseguir clientes potenciales
                                        </p>
                                    </div>
                                    <div className='FreemiumConected-square6_bulletContainer'>
                                        <div className='FreemiumConected-square6_border' />
                                        <img
                                            className='FreemiumConected-square6_bullet'
                                            src={bullet}
                                            alt='bullet'
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className='FreemiumConected-grid4'>
                                <div className='FreemiumConected-square7'>
                                    <div className='FreemiumConected-square7_container'>
                                        <img
                                            className='FreemiumConected-square7_img'
                                            src='/img/freemiumMembershipLanding/Conected/icon7.svg'
                                            alt='servicios'
                                        />
                                        <p className='FreemiumConected-square7_text'>
                                            <b>RESISTENCIA</b> a la implementación de <b>HERRAMIENTAS DIGITALES</b> para la gestión de su despacho
                                        </p>
                                    </div>
                                    <div className='FreemiumConected-square7_bulletContainer'>
                                        <div className='FreemiumConected-square7_border' />
                                        <img
                                            className='FreemiumConected-square7_bullet'
                                            src={bullet}
                                            alt='bullet'
                                        />
                                    </div>
                                </div>
                                <div className='FreemiumConected-square8'>
                                    <div className='FreemiumConected-square8_container'>
                                        <img
                                            className='FreemiumConected-square8_img'
                                            src='/img/freemiumMembershipLanding/Conected/icon8.svg'
                                            alt='visible'
                                        />
                                        <p className='FreemiumConected-square8_text'>
                                            Implementa en su despacho herramientas
                                            digitales <b>INNOVADORAS</b> que optimizan sus servicios
                                        </p>
                                    </div>
                                    <div className='FreemiumConected-square8_bulletContainer'>
                                        <div className='FreemiumConected-square8_border' />
                                        <img
                                            className='FreemiumConected-square8_bullet'
                                            src={bullet}
                                            alt='bullet'
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </div>

                <div class="FreemiumConected-buttonContainer">
                    <LinkScroll to="freemiumForm" smooth="true" duration={500} offset={-60}>
                        <ButtonBase
                            type="submit"
                            variant="secondary"
                            linkStyle={classes.linkStyle}
                            buttonStyle={classes.buttonStyle}
                        >
                            Conviértase en un abogado digital
                        </ButtonBase>
                    </LinkScroll>
                </div>
            </div>
        </div>
    )
}

export default FreemiumConected;






// import React from 'react';
// import { makeStyles } from '@material-ui/styles';
// import { useMediaQuery } from '@material-ui/core';
// import { Link as LinkScroll } from 'react-scroll';
// import ButtonBase from '../../Buttons/ButtonBase';
// import './FreemiumConected.scss';

// const bullet = '/img/freemiumMembershipLanding/Conected/bullet.svg'

// const useStyles = makeStyles({
//     container: {
//         justifyContent: 'center'
//     },
//     buttonStyle: {
//         minWidth: 293,
//     }
// })

// const FreemiumConected = () => {

//     const isMobile = useMediaQuery('(max-width: 999.98px)')
//     const is768 = useMediaQuery('(max-width: 768.98px)')

//     const classes = useStyles()

//     return (
//         <div className='FreemiumConected'>
//             <div className='FreemiumConected-container'>
//                 <p className='FreemiumConected-title'>¿Conectado o fuera de línea?</p>
//                 <p className='FreemiumConected-subtitle'>
//                     La transformación digital en el <b>sector legal</b> ya está aquí, por eso la reputación 
//                     y el posicionamiento online son clave. <b>¿En qué página aparece su despacho en Google?</b>
//                 </p>
//                 <div className='FreemiumConected-subContainer'>
//                     <div className='FreemiumConected-lawyerImageContainer'>
//                         {isMobile ? 
//                             <>
//                                 <img
//                                     className='FreemiumConected-lawyerImage'
//                                     src='/img/freemiumMembershipLanding/Conected/half-gray.png'
//                                     alt='half-gray'
//                                 />
//                             </> :
//                             <>
//                                 <div className='FreemiumConected-border'/>
//                                 <img
//                                     className='FreemiumConected-lawyerImage'
//                                     src='/img/freemiumMembershipLanding/Conected/bicolor-lawyer.png'
//                                     alt='lawyer'
//                                 />
//                             </>
//                         }
//                     </div>

//                     {isMobile ?
//                         // IS MOBILE
//                         <div className='FreemiumConected-gridContainer'>                            
//                             <div className='FreemiumConected-grid1'>
//                                 <div className='FreemiumConected-titles1'>
//                                     <div className='FreemiumConected-titles1_container'>
//                                         <p className='FreemiumConected-titles1_white'>Abogado</p>
//                                         <p className='FreemiumConected-titles1_blue'>TRADICIONAL</p>
//                                     </div>
//                                 </div>
//                                 <div className='FreemiumConected-square1'>
//                                     <div className='FreemiumConected-square1_container'>
//                                         <img
//                                             className='FreemiumConected-square1_img'
//                                             src='/img/freemiumMembershipLanding/Conected/icon1.svg'
//                                             alt='despacho'
//                                         />
//                                         <p className='FreemiumConected-square1_text'>
//                                             Las posibilidades de <b>EXPANSIÓN</b> profesional son <b>LIMITADAS</b>
//                                         </p>
//                                     </div>
//                                     <div className='FreemiumConected-square1_bulletContainer'>
//                                         <div className='FreemiumConected-square1_border' />
//                                         <img
//                                             className='FreemiumConected-square1_bullet'
//                                             src={bullet}
//                                             alt='bullet'
//                                         />
//                                     </div>
//                                 </div>
//                                 <div className='FreemiumConected-square3'>
//                                     <div className='FreemiumConected-square3_container'>
//                                         <img
//                                             className='FreemiumConected-square3_img'
//                                             src='/img/freemiumMembershipLanding/Conected/icon3.svg'
//                                             alt='servicios'
//                                         />
//                                         <p className='FreemiumConected-square3_text'>
//                                             Sus servicios se conocen solo
//                                             entre su círculo de clientes
//                                         </p>
//                                     </div>
//                                     <div className='FreemiumConected-square3_bulletContainer'>
//                                         <div className='FreemiumConected-square3_border' />
//                                         <img
//                                             className='FreemiumConected-square3_bullet'
//                                             src={bullet}
//                                             alt='bullet'
//                                         />
//                                     </div>
//                                 </div>
//                                 <div className='FreemiumConected-square5'>
//                                     <div className='FreemiumConected-square5_container'>
//                                         <img
//                                             className='FreemiumConected-square5_img'
//                                             src='/img/freemiumMembershipLanding/Conected/icon5.svg'
//                                             alt='servicios'
//                                         />
//                                         <p className='FreemiumConected-square5_text'>
//                                             Sus <b>RECOMENDACIONES</b> son <b>INVISIBLES</b> para <b>CLIENTES POTENCIALES</b> en internet
//                                         </p>
//                                     </div>
//                                     <div className='FreemiumConected-square5_bulletContainer'>
//                                         <div className='FreemiumConected-square5_border' />
//                                         <img
//                                             className='FreemiumConected-square5_bullet'
//                                             src={bullet}
//                                             alt='bullet'
//                                         />
//                                     </div>
//                                 </div>
//                                 <div className='FreemiumConected-square7'>
//                                     <div className='FreemiumConected-square7_container'>
//                                         <img
//                                             className='FreemiumConected-square7_img'
//                                             src='/img/freemiumMembershipLanding/Conected/icon7.svg'
//                                             alt='servicios'
//                                         />
//                                         <p className='FreemiumConected-square7_text'>
//                                             <b>RESISTENCIA</b> a la implementación de <b>HERRAMIENTAS DIGITALES</b> para la gestión de su despacho
//                                         </p>
//                                     </div>
//                                     <div className='FreemiumConected-square7_bulletContainer'>
//                                         <div className='FreemiumConected-square7_border' />
//                                         <img
//                                             className='FreemiumConected-square7_bullet'
//                                             src={bullet}
//                                             alt='bullet'
//                                         />
//                                     </div>
//                                 </div>
                                
//                             </div>
    
//                             <div className='FreemiumConected-grid2'>
//                                 <div className='FreemiumConected-titles2'>
//                                     <div className='FreemiumConected-titles2_container'>
//                                         <p className='FreemiumConected-titles2_white'>Abogado</p>
//                                         <p className='FreemiumConected-titles2_blue'>DIGITAL</p>
//                                     </div>
//                                 </div>
//                                 <div className='FreemiumConected-square2'>
//                                     <div className='FreemiumConected-square2_container'>
//                                         <img
//                                             className='FreemiumConected-square2_img'
//                                             src='/img/freemiumMembershipLanding/Conected/icon2.svg'
//                                             alt='reputación'
//                                         />
//                                         <p className='FreemiumConected-square2_text'>
//                                             Se enfoca en gestionar su marca personal
//                                             y <b>REPUTACIÓN</b> a través de internet
//                                         </p>
//                                     </div>
//                                     <div className='FreemiumConected-square2_bulletContainer'>
//                                         <div className='FreemiumConected-square2_border' />
//                                         <img
//                                             className='FreemiumConected-square2_bullet'
//                                             src={bullet}
//                                             alt='bullet'
//                                         />
//                                     </div>
//                                 </div>
//                                 <div className='FreemiumConected-square4'>
//                                     <div className='FreemiumConected-square4_container'>
//                                         <img
//                                             className='FreemiumConected-square4_img'
//                                             src='/img/freemiumMembershipLanding/Conected/icon4.svg'
//                                             alt='visible'
//                                         />
//                                         <p className='FreemiumConected-square4_text'>
//                                             Es <b>VISIBLE</b> en las búsquedas relacionadas
//                                             con su especialidad en Google
//                                         </p>
//                                     </div>
//                                     <div className='FreemiumConected-square4_bulletContainer'>
//                                         <div className='FreemiumConected-square4_border' />
//                                         <img
//                                             className='FreemiumConected-square4_bullet'
//                                             src={bullet}
//                                             alt='bullet'
//                                         />
//                                     </div>
//                                 </div>
//                                 <div className='FreemiumConected-square6'>
//                                     <div className='FreemiumConected-square6_container'>
//                                         <img
//                                             className='FreemiumConected-square6_img'
//                                             src='/img/freemiumMembershipLanding/Conected/icon6.svg'
//                                             alt='visible'
//                                         />
//                                         <p className='FreemiumConected-square6_text'>
//                                             Las <b>RECOMENDACIONES</b> y opiniones sobre sus servicios en
//                                             internet le ayudan a conseguir clientes potenciales
//                                         </p>
//                                     </div>
//                                     <div className='FreemiumConected-square6_bulletContainer'>
//                                         <div className='FreemiumConected-square6_border' />
//                                         <img
//                                             className='FreemiumConected-square6_bullet'
//                                             src={bullet}
//                                             alt='bullet'
//                                         />
//                                     </div>
//                                 </div>
//                                 <div className='FreemiumConected-square8'>
//                                     <div className='FreemiumConected-square8_container'>
//                                         <img
//                                             className='FreemiumConected-square8_img'
//                                             src='/img/freemiumMembershipLanding/Conected/icon8.svg'
//                                             alt='visible'
//                                         />
//                                         <p className='FreemiumConected-square8_text'>
//                                             Implementa en su despacho herramientas
//                                             digitales <b>INNOVADORAS</b> que optimizan sus servicios
//                                         </p>
//                                     </div>
//                                     <div className='FreemiumConected-square8_bulletContainer'>
//                                         <div className='FreemiumConected-square8_border' />
//                                         <img
//                                             className='FreemiumConected-square8_bullet'
//                                             src={bullet}
//                                             alt='bullet'
//                                         />
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                         :
//                         // IS DESKTOP
//                         <div className='FreemiumConected-gridContainer'>

//                             <div className='FreemiumConected-titlesGrid'>
//                                 <div className='FreemiumConected-titles1'>
//                                     <div className='FreemiumConected-titles1_container'>
//                                         <p className='FreemiumConected-titles1_white'>Abogado</p>
//                                         <p className='FreemiumConected-titles1_blue'>TRADICIONAL</p>
//                                     </div>
//                                 </div>
//                                 <div className='FreemiumConected-titles2'>
//                                     <div className='FreemiumConected-titles2_container'>
//                                         <p className='FreemiumConected-titles2_white'>Abogado</p>
//                                         <p className='FreemiumConected-titles2_blue'>DIGITAL</p>
//                                     </div>
//                                 </div>
//                             </div>
                            
//                             <div className='FreemiumConected-grid1'>
//                                 <div className='FreemiumConected-square1'>
//                                     <div className='FreemiumConected-square1_container'>
//                                         <img
//                                             className='FreemiumConected-square1_img'
//                                             src='/img/freemiumMembershipLanding/Conected/icon1.svg'
//                                             alt='despacho'
//                                         />
//                                         <p className='FreemiumConected-square1_text'>
//                                             Las posibilidades de <b>EXPANSIÓN</b> profesional son <b>LIMITADAS</b>
//                                         </p>
//                                     </div>
//                                     <div className='FreemiumConected-square1_bulletContainer'>
//                                         <div className='FreemiumConected-square1_border' />
//                                         <img
//                                             className='FreemiumConected-square1_bullet'
//                                             src={bullet}
//                                             alt='bullet'
//                                         />
//                                     </div>
//                                 </div>
//                                 <div className='FreemiumConected-square2'>
//                                     <div className='FreemiumConected-square2_container'>
//                                         <img
//                                             className='FreemiumConected-square2_img'
//                                             src='/img/freemiumMembershipLanding/Conected/icon2.svg'
//                                             alt='reputación'
//                                         />
//                                         <p className='FreemiumConected-square2_text'>
//                                             Se enfoca en gestionar su marca personal
//                                             y <b>REPUTACIÓN</b> a través de internet
//                                         </p>
//                                     </div>
//                                     <div className='FreemiumConected-square2_bulletContainer'>
//                                         <div className='FreemiumConected-square2_border' />
//                                         <img
//                                             className='FreemiumConected-square2_bullet'
//                                             src={bullet}
//                                             alt='bullet'
//                                         />
//                                     </div>
//                                 </div>
//                             </div>

//                             <div className='FreemiumConected-grid2'>
//                                 <div className='FreemiumConected-square3'>
//                                     <div className='FreemiumConected-square3_container'>
//                                         <img
//                                             className='FreemiumConected-square3_img'
//                                             src='/img/freemiumMembershipLanding/Conected/icon3.svg'
//                                             alt='servicios'
//                                         />
//                                         <p className='FreemiumConected-square3_text'>
//                                             Sus servicios se conocen solo
//                                             entre su círculo de clientes
//                                         </p>
//                                     </div>
//                                     <div className='FreemiumConected-square3_bulletContainer'>
//                                         <div className='FreemiumConected-square3_border' />
//                                         <img
//                                             className='FreemiumConected-square3_bullet'
//                                             src={bullet}
//                                             alt='bullet'
//                                         />
//                                     </div>
//                                 </div>
//                                 <div className='FreemiumConected-square4'>
//                                     <div className='FreemiumConected-square4_container'>
//                                         <img
//                                             className='FreemiumConected-square4_img'
//                                             src='/img/freemiumMembershipLanding/Conected/icon4.svg'
//                                             alt='visible'
//                                         />
//                                         <p className='FreemiumConected-square4_text'>
//                                             Es <b>VISIBLE</b> en las búsquedas relacionadas
//                                             con su especialidad en Google
//                                         </p>
//                                     </div>
//                                     <div className='FreemiumConected-square4_bulletContainer'>
//                                         <div className='FreemiumConected-square4_border' />
//                                         <img
//                                             className='FreemiumConected-square4_bullet'
//                                             src={bullet}
//                                             alt='bullet'
//                                         />
//                                     </div>
//                                 </div>
//                             </div>
                            
//                             <div className='FreemiumConected-grid3'>
//                                 <div className='FreemiumConected-square5'>
//                                     <div className='FreemiumConected-square5_container'>
//                                         <img
//                                             className='FreemiumConected-square5_img'
//                                             src='/img/freemiumMembershipLanding/Conected/icon5.svg'
//                                             alt='servicios'
//                                         />
//                                         <p className='FreemiumConected-square5_text'>
//                                             Sus <b>RECOMENDACIONES</b> son <b>INVISIBLES</b> para <b>CLIENTES POTENCIALES</b> en internet
//                                         </p>
//                                     </div>
//                                     <div className='FreemiumConected-square5_bulletContainer'>
//                                         <div className='FreemiumConected-square5_border' />
//                                         <img
//                                             className='FreemiumConected-square5_bullet'
//                                             src={bullet}
//                                             alt='bullet'
//                                         />
//                                     </div>
//                                 </div>
//                                 <div className='FreemiumConected-square6'>
//                                     <div className='FreemiumConected-square6_container'>
//                                         <img
//                                             className='FreemiumConected-square6_img'
//                                             src='/img/freemiumMembershipLanding/Conected/icon6.svg'
//                                             alt='visible'
//                                         />
//                                         <p className='FreemiumConected-square6_text'>
//                                             Las <b>RECOMENDACIONES</b> y opiniones sobre sus servicios en
//                                             internet le ayudan a conseguir clientes potenciales
//                                         </p>
//                                     </div>
//                                     <div className='FreemiumConected-square6_bulletContainer'>
//                                         <div className='FreemiumConected-square6_border' />
//                                         <img
//                                             className='FreemiumConected-square6_bullet'
//                                             src={bullet}
//                                             alt='bullet'
//                                         />
//                                     </div>
//                                 </div>
//                             </div>

//                             <div className='FreemiumConected-grid4'>
//                                 <div className='FreemiumConected-square7'>
//                                     <div className='FreemiumConected-square7_container'>
//                                         <img
//                                             className='FreemiumConected-square7_img'
//                                             src='/img/freemiumMembershipLanding/Conected/icon7.svg'
//                                             alt='servicios'
//                                         />
//                                         <p className='FreemiumConected-square7_text'>
//                                             <b>RESISTENCIA</b> a la implementación de <b>HERRAMIENTAS DIGITALES</b> para la gestión de su despacho
//                                         </p>
//                                     </div>
//                                     <div className='FreemiumConected-square7_bulletContainer'>
//                                         <div className='FreemiumConected-square7_border' />
//                                         <img
//                                             className='FreemiumConected-square7_bullet'
//                                             src={bullet}
//                                             alt='bullet'
//                                         />
//                                     </div>
//                                 </div>
//                                 <div className='FreemiumConected-square8'>
//                                     <div className='FreemiumConected-square8_container'>
//                                         <img
//                                             className='FreemiumConected-square8_img'
//                                             src='/img/freemiumMembershipLanding/Conected/icon8.svg'
//                                             alt='visible'
//                                         />
//                                         <p className='FreemiumConected-square8_text'>
//                                             Implementa en su despacho herramientas
//                                             digitales <b>INNOVADORAS</b> que optimizan sus servicios
//                                         </p>
//                                     </div>
//                                     <div className='FreemiumConected-square8_bulletContainer'>
//                                         <div className='FreemiumConected-square8_border' />
//                                         <img
//                                             className='FreemiumConected-square8_bullet'
//                                             src={bullet}
//                                             alt='bullet'
//                                         />
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     }

                    
//                 </div>

//                 <div class="FreemiumConected-buttonContainer">
//                     <LinkScroll to="freemiumForm" smooth="true" duration={500} offset={-60}>
//                         <ButtonBase
//                             type="submit"
//                             variant="secondary"
//                             linkStyle={classes.linkStyle}
//                             buttonStyle={classes.buttonStyle}
//                         >
//                             Conviértase en un abogado digital
//                         </ButtonBase>
//                     </LinkScroll>
//                 </div>

//                 {isMobile ?
//                     <>
//                         <div className='FreemiumConected-lawyerImageContainerBottom'>
//                             <img
//                                 className={is768 ? 'FreemiumConected-lawyerImageBottom' : 'FreemiumConected-lawyerImage'}
//                                 src='/img/freemiumMembershipLanding/Conected/half-colorful.png'
//                                 alt='half-colorful'
//                             />
//                         </div>
//                         <div class="FreemiumConected-buttonContainer">
//                             <LinkScroll to="freemiumForm" smooth="true" duration={500} offset={-60}>
//                                 <ButtonBase
//                                     type="submit"
//                                     variant="secondary"
//                                     linkStyle={classes.linkStyle}
//                                     buttonStyle={classes.buttonStyle}
//                                 >
//                                     Conviértase en un abogado digital
//                                 </ButtonBase>
//                             </LinkScroll>
//                         </div>
//                     </>
//                     : null
//                 }
//             </div>
//         </div>
//     )
// }

// export default FreemiumConected;
